export default __webpack_public_path__ + "static/media/baccarat1.05eabbdc.png";